import { Box, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import SectionCard from "../cards/sectionCard/sectionCard";
import StatsPanel from "../cards/statsPanel/statsPanel";

const Sidebar = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box className="netflix_sidebar" sx={{fontFamily: "Lato, sans-serif"}}>
            {/* <StatsPanel/> */}
            <SectionCard
                header="Scratch Club"
                title="Begin Your Scratch Golf Journey"
                desc="Begin the simple 3-step process that consistently lowers your handicap every month."
                icon="https://members.performancegolf.com/wp-content/uploads/2025/04/sc-black.svg"
                locked={window.pgUser?.products?.includes("1")}
                link="/scratch-club"/>

            <SectionCard
                header="VIP Coaching"
                title="1-on-1 Swing Coaching"
                desc="Get unlimited personalized swing reviews from a PGA-level coach."
                icon="https://members.performancegolf.com/wp-content/uploads/2025/04/vip.svg"
                locked={window.pgUser?.products?.includes("2")}
                link={window.pgUser?.products?.includes("2") ? "/vip-coaching" : "https://email.performancegolfzone.net/15H8sm"}/>

            <SectionCard
                header="SwingFix AI"
                title="AI Swing Analysis"
                desc="Use this patent-pending AI technology that analyzes 17 points in your swing to suggest a personalized swing fix."
                icon="https://members.performancegolf.com/wp-content/uploads/2025/04/swing.svg"
                locked={window.pgUser?.products?.includes("1")}
                link={window.pgUser?.products?.includes("1") 
                    ? "https://apps.apple.com/us/app/performance-golf-ai-swing-fix/id1664475856" : "https://www.performancegolf.com/swingfix-ai/swingfix-ai-benefits"}/>
        </Box>
    );
}

export default Sidebar;